export const HOLIDAY_TYPE_CONST = {
  NATIONAL: 1,
  STATE: 2,
  MUNICIPAL: 3,
  OPTIONAL: 4,
};
